module.exports = __webpack_public_path__ + "media/Video 16.08c46c48.mp4";